import React, { createContext, useState } from "react";
import AuthService from "../services/AuthService";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = async (email, password) => {
    const response = await AuthService.login(email, password);
    if (response.success) {
      setUser(response.data); // Kullanıcı bilgilerini kaydet
    }
    return response;
  };

  const changePassword = async (currentPassword, newPassword, confirmNewPassword, ) => {
    const response = await AuthService.changePassword(currentPassword, newPassword, confirmNewPassword);
    return response;
  };

  const logout = async (onNavigate) => {
    const response = await AuthService.logout();
    if (response.success) {
      setUser(null); // Kullanıcı bilgisini temizle
      // Tüm çerezleri temizle
      document.cookie
        .split(";")
        .forEach((cookie) => {
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        });
    }
    return response;
  };

  const signUp = async (userDetails) => {
    const response = await AuthService.signUp(userDetails);
    if (response.success) {
      return response;
    } else {
      return response;
    }
  };
  
  const verifyEmail = async (email, verificationCode) => {
    const response = await AuthService.verifyEmail(email, verificationCode);
    if (response.success) {
      return response;
    } else {
      return response;
    }
  };
  
  const sendVerificationCode = async (email) => {
    const response = await AuthService.sendVerificationCode(email);
    if (response.success) {
      return response;
    } else {
      return response;
    }
  };
  
  const resetPassword = async (resetData) => {
    const response = await AuthService.resetPassword(resetData);
    if (response.success) {
      return response;
    } else {
      return response;
    }
  };
  
  const fetchQuotaInfo = async () => {
    const response = await AuthService.getQuotaInfo();
    return response;
  };

  
  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        signUp,
        verifyEmail,
        sendVerificationCode,
        resetPassword,
        changePassword,
        fetchQuotaInfo,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};